import React from 'react';
// @mui
import { Box, Button, Card, Container, Stack, Typography } from '@mui/material';
// components
import { Helmet } from 'react-helmet-async';
import config from '../config';
import i18n from '../i18n';
import AdminDashboardContent from './dashboards/AdminDashboardContent';
import MerchantDashboardContent from './dashboards/MerchantDashboardContent';
import GatewayDashboardContent from './dashboards/GatewayDashboardContent';

// ----------------------------------------------------------------------

export default class DashboardAppPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: {},
            error: null,
            isLoading: true,
        };
    }
    componentDidMount() {
        // Every grid page heads the bar with its name; the dashboard left it
        // empty, so the bar sat blank over the first screen after sign-in.
        // The empty caption line is the grids' breadcrumb row, so the title
        // sits at the same height as theirs.
        this.props.setHeaderActions?.(
            <Box sx={{ minWidth: 0 }}>
                <Box sx={{ typography: 'caption' }} aria-hidden>
                    {'\u00A0'}
                </Box>
                <Typography variant="h5" color="text.primary" noWrap>
                    {i18n.t('menu.dashboard')}
                </Typography>
            </Box>
        );
        this.load();
    }

    // A failed request used to leave the skeletons up for good; now it says so
    // and offers to try again.
    load = () => {
        const { server } = this.props.context.getState();
        this.setState({ isLoading: true, error: null });
        server.users
            .dashboardInfo()
            .then((data) => {
                if (!data) throw new Error('dashboard-info');
                this.setState({ data, isLoading: false });
            })
            .catch((error) => {
                this.setState({ error: error || true, isLoading: false });
            });
    };

    renderError() {
        return (
            <Card>
                <Stack spacing={2} alignItems="center" sx={{ py: 8, px: 3, textAlign: 'center' }}>
                    <Typography variant="h6">
                        {i18n.t('dashboard.loadFailed')}
                    </Typography>
                    <Button variant="contained" onClick={this.load}>
                        {i18n.t('dashboard.retry')}
                    </Button>
                </Stack>
            </Card>
        );
    }

    componentWillUnmount() {
        this.props.clearHeaderActions?.();
    }

    render() {
        let role = this.state.data ? localStorage.systemRole : '';

        const title = config.title
            ? `Dashboard | ${config.title}`
            : 'Dashboard';
        return (
            <>
                <Helmet>
                    <title>{title}</title>
                </Helmet>

                <Container maxWidth="xl">
                    {this.state.error && this.renderError()}
                    {!this.state.error && role === 'admin' && (
                        <AdminDashboardContent
                            {...this.props}
                            data={this.state.data}
                            isLoading={this.state.isLoading}
                        />
                    )}
                    {!this.state.error && role === 'merchant' && (
                        <MerchantDashboardContent
                            {...this.props}
                            data={this.state.data}
                            isLoading={this.state.isLoading}
                        />
                    )}
                    {!this.state.error && role === 'gateway' && (
                        <GatewayDashboardContent
                            {...this.props}
                            data={this.state.data}
                            isLoading={this.state.isLoading}
                        />
                    )}
                </Container>
            </>
        );
    }
}
